import { type ReactElement } from 'react'
import { isEmpty, isNotEmpty, type SmallUser } from '@terros/common'
import { Link } from '@tanstack/react-router'
import { Alert, Loader } from '@mantine/core'
import { TSectionList } from '../terros'
import { UserInfo } from '../entityInfo'
import { TButton } from '../buttons'

type Props = {
  isLoading: boolean
  users: SmallUser[] | undefined
}

export const DuplicateUsers = ({ isLoading, users }: Props): ReactElement => {
  return (
    <TSectionList heading={{ title: 'Possible Duplicate Users' }}>
      {isLoading && <Loader />}
      {!isLoading && isEmpty(users) && <Alert>No possible duplicate users found</Alert>}
      {isNotEmpty(users) && (
        <>
          <Alert color='red'>Possible duplicate users found</Alert>
          {users.map((u) => (
            <TButton
              component={Link}
              justify='start'
              key={u.userId}
              size='medium'
              to={`/user/${u.userId}`}
              variant='ghost'
            >
              <UserInfo {...u} linked={false} />
            </TButton>
          ))}
        </>
      )}
    </TSectionList>
  )
}
